import { render, staticRenderFns } from "./topBack.vue?vue&type=template&id=0d895270&scoped=true&lang=pug"
import script from "./topBack.vue?vue&type=script&lang=ts"
export * from "./topBack.vue?vue&type=script&lang=ts"
import style0 from "./topBack.vue?vue&type=style&index=0&id=0d895270&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d895270",
  null
  
)

export default component.exports